import { render, staticRenderFns } from "./AppFileInput.vue?vue&type=template&id=21c08dc8&scoped=true&"
import script from "./AppFileInput.vue?vue&type=script&lang=js&"
export * from "./AppFileInput.vue?vue&type=script&lang=js&"
import style0 from "./AppFileInput.vue?vue&type=style&index=0&id=21c08dc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c08dc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VFileInput,VIcon})
